import Link from 'next/link';
import { clsx } from 'clsx';

type CmsButtonProps = {
  link: {
    __typename?: 'Link';
    title?: string | null;
    url?: string | null;
  };
  index?: number;
  isInverted?: boolean | null | undefined;
  isOutline?: boolean | null | undefined;
  isLarge?: boolean | null | undefined;
};

export function CmsButton({
  link,
  isInverted,
  isOutline,
  isLarge,
}: CmsButtonProps) {
  if (!link.url) {
    return null;
  }

  return (
    <Link
      href={link.url}
      className={clsx(
        'caps-lg mt-2 inline-flex flex-shrink-0 justify-center rounded-md text-center transition-colors hover:no-underline',
        isLarge ? 'px-5 py-3.5' : 'px-4 py-2.5',
        isInverted
          ? 'bg-primary-contrastText text-primary-main hover:bg-primary-main hover:text-primary-contrastText'
          : 'bg-primary-main text-primary-contrastText hover:bg-secondary-main hover:text-secondary-contrastText',
        !isInverted &&
        isOutline &&
        'border border-secondary-main bg-white text-secondary-main hover:bg-secondary-main hover:text-primary-contrastText'
      )}
    >
      {link.title || 'Learn More'}
    </Link>
  );
}
